import image1 from "../../assets/images/cspro-images/cspro-image1.png";
import image2 from "../../assets/images/cspro-images/cspro-image2.png";
import image3 from "../../assets/images/cspro-images/cspro-image3.png";
import image4 from "../../assets/images/cspro-images/cspro-image4.png";
import image5 from "../../assets/images/cspro-images/cspro-image5.png";
import image6 from "../../assets/images/cspro-images/cspro-image6.png";
import React from 'react';
import { Carousel } from 'antd';


const imageStyle = {
  width: '100%',
  objectFit: 'cover',
  aspectRatio: '1/1',
  borderRadius: '20px'
};




const CsproCarousel = () => (
 <Carousel autoplay effect="fade"  className='cspro-carousel'>
    
    
        <div style={{ position: 'relative'}}>
             <img
                 className="d-block w-100 img-fluid"
                 src={image1}
                 style={imageStyle}
                 alt="First slide"
             />
             <div className="banner_text_">
                 <h3 className="responsive-text-1">
                     "We always prefer hiring trained professionals from cybersquare pro as the candidates are really good"
                 </h3>
             </div>
        </div>

    
        <div style={{ position: 'relative'}}>
             <img
                 className="d-block w-100 img-fluid"
                 src={image2}
                 style={imageStyle}
                 alt="Second slide"
             />
             <div className="banner_text_1">
              <h3 className="responsive-heading_2">Get Skilled for Job</h3>
              <span className="responsive-text_2">
                 Get trained and skilled under the guidance of expert software engineers and be ready for the jobs.
              </span>
             </div>
        </div>
  
   
        <div style={{ position: 'relative'}}>
        <img
            className="d-block w-100 img-fluid"
            src={image3}
            style={{imageStyle}}
            alt="Third slide"
            />

        <div className="banner_text_">
                <h1 className="responsive-heading_3">20+</h1>
                <h1 className="responsive-text_3">
                    Hiring Partners
                </h1>
        </div>
        </div>

        <div>
        <img
            className="d-block w-100 img-fluid"
            src={image4}
            style={{imageStyle}}
            alt="Fourth slide"
            />
        </div>

        <div>
        <img
            className="d-block w-100 img-fluid"
            src={image5}
            style={{imageStyle}}
            alt="Fifth slide"
            />
        </div>

        <div>
        <img
            className="d-block w-100 img-fluid"
            src={image6}
            style={{imageStyle}}
            alt="Sixth slide"
            />
        </div>

  </Carousel>
);

export default CsproCarousel;